import { ConnectionConfig } from './types';

export const WEBSOCKET_CONFIG: Omit<ConnectionConfig, 'uri'> = {
  connectionTimeout: 3000,
  reconnectDelay: 5000,
  initialConnectDelay: 2000,
  maxRetries: 5,
} as const;

export const TOAST_CONFIG = {
  duration: {
    success: 10000,
    error: 5000,
    warning: 5000,
    info: 3000,
  },
  position: 'bottom' as const,
} as const;
